export class Dashboard {

    public DashboardIdentifier: string;
    public Label: string;
    public EntityName: string;
    constructor(dashboardIdentifier: string, label: string) {
        this.DashboardIdentifier = dashboardIdentifier;
        this.Label = label;
    }
}